module.exports = __webpack_public_path__ + "static/media/quick_fire.dd0b6a98.png";